import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityFactory } from '../factory/entity-factory';
import { HttpError } from '../error/http-error';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class HttpService {

  isLoading$: Observable<boolean>;

  private isLoadingSubject: Subject<boolean>;

  constructor(private _http: HttpClient) {
    this.isLoadingSubject = new Subject();
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  post(URL: string, payload, ResponseType, ErrorType) {
    const typedResponse = this.getCorrectTypeInstanceFrom(ResponseType);
    const typedError: HttpError = this.getCorrectTypeInstanceFrom(ErrorType);
    this.isLoadingSubject.next(true);
    const request = this._http.post(URL, payload);
    return this.applyMapCatchFinally(request, typedError, typedResponse);
  }

  get(URL: string, ResponseType, ErrorType) {
    const typedResponse = this.getCorrectTypeInstanceFrom(ResponseType);
    const typedError: HttpError = this.getCorrectTypeInstanceFrom(ErrorType);
    this.isLoadingSubject.next(true);
    const request = this._http.get(URL);
    return this.applyMapCatchFinally(request, typedError, typedResponse);
  }

  put(URL: string, payload, ResponseType, ErrorType) {
    const typedResponse = this.getCorrectTypeInstanceFrom(ResponseType);
    const typedError: HttpError = this.getCorrectTypeInstanceFrom(ErrorType);
    this.isLoadingSubject.next(true);
    const request = this._http.put(URL, payload);
    return this.applyMapCatchFinally(request, typedError, typedResponse);
  }

  delete(URL: string, ErrorType, ResponseType?) {
    const typedError: HttpError = this.getCorrectTypeInstanceFrom(ErrorType);
    this.isLoadingSubject.next(true);
    const request = this._http.delete(URL);
    if (ResponseType) {
      const typedResponse = this.getCorrectTypeInstanceFrom(ResponseType);
      return this.applyMapCatchFinally(request, typedError, typedResponse);
    }
    return this.applyMapCatchFinally(request, typedError);
  }

  private applyMapCatchFinally(request, typedError, typedResponse?) {
    request = this.applyMap(request, typedResponse);
    request = this.applyCatch(request, typedError);
    request = this.applyFinally(request);
    return request;
  }

  private applyMap(request, typedResponse) {
    if (typedResponse) {
      return request
        .map(res => {
          return Object.assign(typedResponse, res);
        });
    }
    return request;
  }

  private applyCatch(request, typedError) {
    return request
      .catch(error => {
        typedError.text = this.getErrorMessage(error);
        return Observable.throw(typedError);
      });
  }

  private applyFinally(request) {
    return request
      .finally(() => this.isLoadingSubject.next(false));
  }

  private getCorrectTypeInstanceFrom(Type) {
    return EntityFactory.getEntityInstance(Type);
  }

  private getErrorMessage(error) {
    if (error.error && error.error.message) {
      return error.error.message;
    } else {
      const insideError = JSON.parse(error.error);
      if (insideError.message) {
        return insideError.message;
      }
    }
    if (error.message) {
      return error.message;
    }
    return 'Algo de errado ocorreu';
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/http.service.ts